import { render, staticRenderFns } from "./componyInfo.vue?vue&type=template&id=bcec981c"
import script from "./componyInfo.vue?vue&type=script&lang=js"
export * from "./componyInfo.vue?vue&type=script&lang=js"
import style0 from "./componyInfo.vue?vue&type=style&index=0&id=bcec981c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports